<template>
  <headerBar></headerBar>
  <div id="container">
    <loadingBox :isLoading="this.$store.state.pageLoading" :loadData="pageLoadData"></loadingBox>
    <el-button
      id="sideBtn"
      type="info"
      style="position: fixed; top: 83%; left: 0px; z-index: 9999"
      class="rwd-md-show"
      :icon="rwdMenuOpenIcon"
      @click="this.rwdMenuClose = !this.rwdMenuClose"
    ></el-button>

    <div class="row g-0">
      <div
        id="menuPanel"
        :class="{
          'rwd-md-show': isSmallScreen,
          'col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 large-screen': !isSmallScreen,
          menuClose: !menuOpen,
          rwdClose: !rwdMenuClose,
        }"
      >
        <el-button
          id="sideBtn"
          type="info"
          :icon="menuOpenIcon"
          @click="this.menuOpen = !this.menuOpen"
          class="rwd-md-hide"
        ></el-button>
        <sideMenu></sideMenu>
      </div>
      <div
        id="mainFrame"
        class="col p-4"
        :class="{ menuClose: !menuOpen, 'rwd-md-show': isSmallScreen }"
      >
        <router-view />
      </div>
    </div>

    <!-- 全域浮動式按鈕-->
    <floatButton
      :driverTourRouteSourceList="routeList"
      :clickOpenHelpDriverTour="openHelpDriverTour"
    ></floatButton>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-const */
import { useI18n } from '@/js/i18n';
import headerBar from '@/components/headerBar.vue';
import sideMenu from '@/views/System/components/sideMenu.vue';
import loadingBox from '@/components/loading.vue';
import { computed } from 'vue';
import { getDriverTourRouteListForSystem } from '@/js/help/routeList';
import { openHelpDriverTourSystem } from '@/js/help/core/openHelpDriverTourCore';
import floatButton from '@/components/helpDriver/floatButton.vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';

export default {
  name: 'sys-admin',

  setup() {
    const i18n = useI18n();
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    return {
      i18n,
      store,
      openHelpDriverTour(clickId) {
        openHelpDriverTourSystem(clickId, { store, route, router, i18n });
      },
    };
  },
  computed: {
    menuOpenIcon() {
      if (!this.menuOpen) {
        return 'ArrowRightBold';
      }
      return 'ArrowLeftBold';
    },
    rwdMenuOpenIcon() {
      if (!this.rwdMenuClose) {
        return 'ArrowRightBold';
      }
      return 'ArrowLeftBold';
    },
  },
  components: {
    headerBar,
    sideMenu,
    loadingBox,
    floatButton,
  },
  data() {
    return {
      rwdMenuClose: false,
      isSmallScreen: window.innerWidth < 1000,
      menuOpen: true,
      changUIName: '',
      pageLoadData: {
        background: '#000',
        cancel: false,
        full: true,
        loader: 'dots',
        transition: 'fade',
        color: '#fff',
        afterText: computed(() => {
          return `${this.i18n.$t('Button').confirm}【${this.changUIName}】${
            this.i18n.$t('Msg').switchDB
          }`;
        }),
        textStyle:
          'font-size: 1.3rem; color: #fff; text-shadow: 0px 0px 10px #000; padding-left: 15px;',
      },

      /** 功能路由列表 */
      routeList: [],
    };
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.$store.watch(
      () => {
        return this.$store.state.LoadingName;
      },
      (newValue, oldValue) => {
        // console.log(`old : ${oldValue}`);
        // console.log(`new : ${newValue}`);
        if (oldValue !== newValue) {
          this.changUIName = newValue;
        }
      },
    );
    this.$watch(
      () => {
        return this.$route;
      },
      (to, from) => {
        if (to !== from) {
          this.rwdMenuClose = false;
        }
      },
    );
  },
  methods: {
    handleResize() {
      this.isSmallScreen = window.innerWidth < 1000;
      if (this.isSmallScreen) {
        this.rwdMenuClose = false;
        this.menuOpen = true;
      }
    },
  },

  watch: {
    '$store.state.lang': {
      handler(val, old) {
        console.log('store.state.lang val', val);
        console.log('store.state.lang old', old);
        this.routeList = getDriverTourRouteListForSystem(this.i18n);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style scoped>
#menuPanel.rwd-md-show {
  width: 100%;
}

.rwd-md-show.rwdClose {
  margin-left: -100%;
}

@media (max-width: 999px) {
  .rwd-md-hide {
    display: none;
  }
}

@media (min-width: 1000px) {
  :deep(.el-button.el-button--info.rwd-md-show) {
    display: none;
  }

  :deep(.el-button.el-button--info.rwd-md-show) {
    display: none;
  }
}
</style>
